module.exports = __webpack_public_path__ + "img/slide5.9ab08636.png";